import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import { BrowserRouter } from "react-router-dom";
import WidthProvider from "./context/WidthProvider.jsx";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <WidthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </WidthProvider>
  </React.StrictMode>
);
